import { FILTERS } from '../constants/filters';
import { COLUMN_NAME, GOAL_CATEGORY } from '../constants/goals';
import { GOALS_TABLE_COLUMN_CONFIG } from './goalsTableColumnConfig';
export const GOAL_CATEGORY_TABLE_CONFIG = () => {
  const goalProgress = GOALS_TABLE_COLUMN_CONFIG[COLUMN_NAME.PROGRESS];
  const adCampaigns = GOALS_TABLE_COLUMN_CONFIG[COLUMN_NAME.AD_CAMPAIGNS];
  const goalName = GOALS_TABLE_COLUMN_CONFIG[COLUMN_NAME.GOAL_NAME];
  const goalDuration = GOALS_TABLE_COLUMN_CONFIG[COLUMN_NAME.DURATION];
  const goalStatus = GOALS_TABLE_COLUMN_CONFIG[COLUMN_NAME.STATUS];
  return {
    [GOAL_CATEGORY.MARKETING]: {
      filters: [FILTERS.END_DATE, FILTERS.GOAL_TYPE, FILTERS.MILESTONES, FILTERS.PERCENT_PROGRESS, FILTERS.STATUS, FILTERS.AD_ACCOUNTS],
      columns: [goalName, adCampaigns, goalDuration, goalProgress, goalStatus]
    }
  };
};